import React, { FC } from 'react';
import * as Contentful from 'contentful';
import {
  TypeAddToCartCtaFields,
  TypeLink_externalFields,
  TypeLink_internalFields,
} from '@/core/generated-types';
import classNames from 'classnames';
import { UniversalLink } from '@/components/common';

interface LinkProps {
  link: Contentful.Entry<
    TypeLink_internalFields | TypeLink_externalFields | TypeAddToCartCtaFields
  >;
  classes?: string;
}

const CTA: FC<LinkProps> = ({ link, classes }) => {
  if (!link?.sys) return null;

  return (
    <div className={classNames(classes ? classes : 'lg:inline-block')}>
      <UniversalLink
        link={link}
        classes={classNames('btn-primary btn lg:btn-lg', classes)}
        hideArrow
      />
    </div>
  );
};

export default React.memo(CTA);
